import ReactDOM from 'react-dom/client';
import App from './App';
import ReactGA from "react-ga4";

ReactGA.initialize( process.env.REACT_APP_GA4_ID || '')

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);